<template>
  <NotFoundView />
</template>
<script lang="ts" setup>
const route = useRoute();
const router = useRouter();
// `/core/x/y/z/` -> `/x/y/z`
onMounted(() => {
  const path = route.path
    .split('/')
    .filter((p) => Boolean(p))
    .filter((p) => p !== 'core')
    .join('/');
  const routes = router.getRoutes().map((r) => r.path);
  const match = routes.find((r) => r === `/${path}/` || r === `/${path}`); // Just in case.
  if (match !== undefined) {
    const destRoute = router.resolve(match);
    router.push(destRoute);
  }
});
</script>
